import { render, staticRenderFns } from "./DisbarmentList.vue?vue&type=template&id=1563d59b&scoped=true&"
import script from "./DisbarmentList.vue?vue&type=script&lang=js&"
export * from "./DisbarmentList.vue?vue&type=script&lang=js&"
import style0 from "./DisbarmentList.vue?vue&type=style&index=0&id=1563d59b&lang=scss&scoped=true&"
import style1 from "./DisbarmentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563d59b",
  null
  
)

export default component.exports